import { NavLink } from 'react-router-dom';
import styles from "./MobileNavBar.module.css";
import { animateCSS } from "../../helpers/globals";

// eslint-disable-next-line
import * as globals from "../../helpers/globals";

import myPhotoRight_Thumb1x from "./../../assets/HomePage/MyPhotoThumbnail/My_Photo_Right_1x.webp";
import myPhotoRight_Thumb2x from "./../../assets/HomePage/MyPhotoThumbnail/My_Photo_Right_2x.webp";
import hamburderMenuIcon from "../../assets/icons/Hamburder Menu Icon White.svg";

export default function MobileNavBar() {
  function openMenuPanel() {
    const navBarPanel = document.getElementById("navBarPanel");

    if (navBarPanel) {
      navBarPanel.style.display = "block";
      animateCSS("#navBarPanel", "animate__slideInDown");
    } else {
      navBarPanel.style.display = "none";
    }
  }

  return (
    <div id="mobileNavBar" className={styles.mobileNavBar}>
      <img
        className={styles.myPhotoThumb}
        srcSet={myPhotoRight_Thumb1x + ", " + myPhotoRight_Thumb2x + " 2x"}
        src={myPhotoRight_Thumb1x}
        alt="Jagdish Thumbnail"
      />
      <NavLink to="/" className={styles.appTitle}>
        JAGDISH CHOPDE
      </NavLink>
      <button
        id="hamburderMenuIconBtn"
        className={styles.hamburderMenuIcon}
        onClick={openMenuPanel}
      >
        <img src={hamburderMenuIcon} alt="Menu Icon" />
      </button>
    </div>
  );
}
